import React, { Component } from 'react';

import Table from '../d-Table/Table'
import Sources from '../f-Utilities/Sources'
import Info from '../f-Utilities/Info'

import LeafletMapOrganizationProfile from '../b-LeafletMap/LeafletMapOrganizationProfile';
import GriddedPopulation from '../2-TerritoryProfile/GriddedPopulation';


class PopulationOrganization extends React.Component {
  constructor(props) {
    super(props);

    var communes = this.props.territory.communes;

    this.state = {
      selected: "population",
      viewMap: "map",
    };
  }

    displayCategory = (cat) => {
        this.setState({
          selected: cat,
        })
    }
    setView = (view) => {
        this.setState({
          viewMap: view,
        })
    }
    downloadCSV = (view) => {
      const rows = [
          ["name1", "city1", "some other info"],
          ["name2", "city2", "more info"]
      ];

      let csvContent = "data:text/csv;charset=utf-8,"
          + rows.map(e => e.join(",")).join("\n");

          var encodedUri = encodeURI(csvContent);
    window.open(encodedUri);
    }

  render() {
    var communes = this.props.territory.communes;
    return(
          <div className="row content">

            <div className="col-3">
                <div className="row">
                  <div className="col-12">
                    <h3 className="mb-3">organisation géographique de la population</h3>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 line-border">
                    <p
                    className={this.state.selected === "population" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                    onClick={this.displayCategory.bind(this, "population")}>population</p>
                    <p
                    className={this.state.selected === "corrected_density" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                    onClick={this.displayCategory.bind(this, "corrected_density")}>densité corrigée</p>
                    <p
                    className={this.state.selected === "gridded_population" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                    onClick={this.displayCategory.bind(this, "gridded_population")}>population carroyée</p>
                    <p
                    className={this.state.selected === "gridded_population_hh" ?
                      "mb-2 mt-1 datalist selected" : "mb-2 mt-1 datalist"}
                    onClick={this.displayCategory.bind(this, "gridded_population_hh")}>taille des ménages carroyée</p>
                  </div>
                </div>


                <div className="row mt-5">
                  <div className="col-12">
                    <p className="mb-2">La densité corrigée est basée sur la surface urbanisée uniquement.
                    Elle représente la manière dont la population occupe les sols.</p>

                    <p className="mb-2">La population carroyée est la population par carreau de 200m de côté.</p>
                    <p>La taille des ménages est en moyenne de <b>2.2</b> en France. <Info content="La taille des ménages au carreau est le rapport entre la population et le nombre de ménage du carreau."/></p>
                  </div>
                </div>
            </div>

            <div className="col-9">
              <div className="row" style={{display: this.state.viewMap == "map" ? "block" : "none"}}>
                <div className="col">
                <LeafletMapOrganizationProfile
                                   territory={this.props.territory}
                                   selected={this.state.selected}
                                   id="population_organization"/>
                </div>
              </div>

              <div className="row" style={{display: this.state.viewMap == "map" ? "none" : "block"}}>
                <div className="col">
                 <Table headlines={["Code Insee", "Nom de la commune", "Population", "Densité (hab/km²)", "Densité corrigé (hab/km²)"]}
                        tables={[communes.map((c)=> c.geo_code),
                                 communes.map((c)=> c.name),
                                 communes.map((c)=> c.population != null ? c.population.toLocaleString("fr-FR") : null),
                                 communes.map((c)=> c.density != null ? c.density.toLocaleString("fr-FR") : null),
                                 communes.map((c)=> c.corrected_density != null ? c.corrected_density.toLocaleString("fr-FR") : null)] }
                        align={["l", "l", "r", "r", "r"]}
                        height="500px"/>

                </div>
              </div>

              <div className="row mt-1">
                <div className="col-10">
                 <Sources sources={this.props.territory.sources}
                        concerned={["dossier_complet", "surface", "artificialisation_rate", "gridded_pop"]}/>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-2 pr-0">
                  <p onClick={this.setView.bind(this, "map")}
                     className={this.state.viewMap == "map" ? "button p-1 active" : "button p-1"}>Carte</p>
                </div>
                <div className="col-2 pr-0">
                  <p onClick={this.setView.bind(this, "table")}
                     className={this.state.viewMap == "table" ? "button p-1 active" : "button p-1"}>Tableau</p>
                </div>

                <div className="col-auto" style={{display: "none"}}>
                  <p onClick={this.downloadCSV.bind(this)}
                     className="button p-1">Télécharger le tableau au format csv</p>
                </div>
              </div>

            </div>

          </div>
    )
  }
}

export default PopulationOrganization;
